import { action } from 'satcheljs';
import ComposeSmartPillData from '../store/schema/ComposeSmartPillData';

export const addPill = action('addPill', (pillData: ComposeSmartPillData) => ({
    pillData: pillData,
}));

export const removePill = action('removePill', (pillId: string) => ({
    pillId: pillId,
}));

export const clearPills = action('clearPills');
